import React, { ChangeEvent, FunctionComponent } from 'react';
import classNames from 'classnames';
import styles from './main.scss';

type SwitchProps = {
    checked: boolean;
    children?: React.ReactNode;
    dataTn: string;
    label?: React.ReactNode;
    name?: string;
    onText?: React.ReactNode;
    offText?: React.ReactNode;
    onChange: (checked: boolean, e?: ChangeEvent<HTMLInputElement>) => void | null;
    value?: string | number;
};

export const Switch: FunctionComponent<SwitchProps> = props => {
    const { children, dataTn, label, name, onText = 'I', offText = 'O', value, checked } = props;

    function onChange(e: ChangeEvent<HTMLInputElement>): void {
        const { checked: nextChecked } = e && e.currentTarget;

        /* istanbul ignore else */
        if (typeof nextChecked === 'boolean') {
            if (props.onChange) {
                props.onChange(nextChecked, e);
            }
        }
    }

    const switchClasses = classNames(styles.switch, {
        [styles.isChecked]: checked,
    });

    const sliderClasses = classNames(styles.slider, {
        [styles.isActive]: checked,
    });

    return (
        <div className={styles.wrapper}>
            {label && <div className={styles.label}>{label}</div>}
            <label htmlFor={name} className={switchClasses} data-tn={`${dataTn}-label`}>
                <input
                    id={name}
                    name={name}
                    type={'checkbox'}
                    className={styles.hiddenInput}
                    checked={checked}
                    onChange={onChange}
                    value={value}
                    data-tn={`${dataTn}-input`}
                />
                <div className={styles.dot} />
                <div className={sliderClasses}>
                    <div className={styles.sliderTextOn}>{onText}</div>
                    <div className={styles.sliderTextOff}>{offText}</div>
                </div>
            </label>
            {children}
        </div>
    );
};
